<div class="row cfa-nowrap-row cfa-button">
  <div class="col-auto pl-0 pr-0 align-self-center">
    <img src="{{getIconUrl()}}" width="37px" height="37px">
  </div>
  @if (appName) {
    <div class="col-auto align-self-center pl-2 pr-0">
      @for (line of appName.split(' '); track line) {
        <div class="row cfa-nowrap-row">
          <div class="col-auto pr-0 pl-0 text-left">
            <span class="cfa-11 cfa-normal-font">
              {{line}}
            </span>
          </div>
        </div>
      }
    </div>
  }
</div>
